// Public Microsoft Bookings page for demo requests. Opened in a new tab rather than
// embedded, so no Microsoft cookies are set on our site (no consent banner needed).
export const BOOKING_URL =
  'https://bookings.cloud.microsoft/book/OPTEAMServices1@opteam-services.com/?ismsaljsauthenabled';
